// @flow
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import Input from 'antd/lib/input';
import { RangePicker } from '../../../components/ui';

import {
  Filter,
  FilterButtonsContainer,
  FilterContainer,
  FilterItem,
  Selects,
} from './../../../components';
import Field from './../../../components/card/Field';
import type { FilterChildrenParams } from './../../../components/hoc/Filter';
import { formatDateTimeToISOString } from './../../../lib/helpers';

const { CompanySelect } = Selects;

const SpoilerContent = styled.div`
  padding: 16px;
`;

export type BioTreatmentFacilitiesFilterParams = {
  licensePlate?: string,
  'bioTreatmentFacilityVolume.bioTreatmentFacilityContract.companyId'?: number,
};

type Props = {
  filter: BioTreatmentFacilitiesFilterParams,
  cleanFilter: Function,
  applyFilter: Function,
};

export const ContractFilter = ({ filter, cleanFilter, applyFilter }: Props) => (
  <SpoilerContent>
    <FilterContainer>
      <Filter
        cleanFilter={cleanFilter}
        applyFilter={applyFilter}
        initialValues={filter}
        withOutQuery
      >
        {({
          values,
          changeValue,
          applyFilter,
          cleanFilter,
        }: FilterChildrenParams<BioTreatmentFacilitiesFilterParams>) => (
          <>
            <FilterItem>
              <Field mBottomNone>
                <Input
                  size="small"
                  placeholder="Номер ТС"
                  onChange={(e) => changeValue('licensePlate', e.target.value)}
                  value={values.licensePlate}
                />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <CompanySelect
                  size="small"
                  placeholder="Контрагент"
                  onChange={(value) =>
                    changeValue(
                      'bioTreatmentFacilityVolume.bioTreatmentFacilityContract.companyId',
                      value
                    )
                  }
                  value={
                    values[
                      'bioTreatmentFacilityVolume.bioTreatmentFacilityContract.companyId'
                    ]
                  }
                />
              </Field>
            </FilterItem>
            <FilterButtonsContainer
              applyFilter={applyFilter}
              cleanFilter={cleanFilter}
            />
          </>
        )}
      </Filter>
    </FilterContainer>
  </SpoilerContent>
);

export default ContractFilter;
